import AppConstants from '../config/app.constants';

let AtmMakesService = function ($http, $q) {

    let all = (query, offset, limit, active) => {
        return $http
            .get(AppConstants.api + `/atm-makes`, {
                params: {
                    query,
                    offset,
                    limit,
                    active
                }
            })
            .then((res) => {
                return res.data;
            });
    };

    let create = (data) => {
        return $http
            .post(AppConstants.api + `/atm-makes`, data)
            .then((res) => {
                return res.data;
            });
    };

    let update = (id, data) => {
        return $http
            .put(AppConstants.api + `/atm-makes/${id}`, data)
            .then((res) => {
                return res.data;
            });
    };

    let remove = (id) => {
        return $http
            .delete(AppConstants.api + `/atm-makes/${id}`)
            .then((res) => {
                return res.data;
            });
    };

    return {
        all,
        create,
        update,
        remove
    };
};

AtmMakesService.$inject = ['$http', '$q'];

export default AtmMakesService;



// WEBPACK FOOTER //
// ./client/app/services/atm-makes.service.js